export default defineNuxtPlugin((nuxtApp) => {
  const checkSupportWebp = () => {
    try {
      return (
        document
          .createElement('canvas')
          .toDataURL('image/webp', 0.5)
          .indexOf('data:image/webp') === 0
      );
    }
    catch {
      return false;
    }
  };

  nuxtApp.hook('app:created', () => {
    const isWebpSupport = checkSupportWebp();
    nuxtApp.provide('isWebpSupport', isWebpSupport);
  });
});
